module.exports = __webpack_public_path__ + "static/media/insurance_item-04.0943be4c.svg";